<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M53.48 48.11l-3.37-6.75A10.47 10.47 0 0149 36.67V26A17 17 0 0033.5 9.08V6.5a1.5 1.5 0 00-3 0v2.58A17 17 0 0015 26v10.67a10.47 10.47 0 01-1.11 4.69l-3.37 6.75A2 2 0 0012.31 51h10.32a9.49 9.49 0 0018.74 0h10.32a2 2 0 001.79-2.89zM32 56a6.51 6.51 0 01-6.32-5h12.64A6.51 6.51 0 0132 56zm-18.07-8l2.64-5.29a12.6 12.6 0 00.85-2.21h9.08a1 1 0 000-2h-8.64a14.09 14.09 0 00.14-1.83V26a14 14 0 0128 0v10.67a13.51 13.51 0 001.43 6L50.07 48z"/></svg>